// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hero-banner-v2--authoring .heroCardsContentWrapper{height:500px}.hero-banner-v2--authoring .heroCardsContentWrapper .imageWrapper{height:100%}.hero-banner-v2--authoring .authorWrapperGlobal{position:relative;height:auto;margin-bottom:60px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
